import React, { useEffect } from 'react'
import Header2 from '../../layout/Header2'
import { Helmet, HelmetProvider } from 'react-helmet-async'
import { useLanguage } from '../../contexts/LanguageContext'
import { Link } from 'react-router-dom'
import ServicesBanner from '../../components/haseeb/ServicesBanner'
import BannerImg from '../../assets/images/bannners/VideoAnimation.webp'
import Img1 from '../../assets/images/video-animation/Img1.gif'
import Gif1 from '../../assets/images/video-animation/Gif1.gif'
import Animation from '../../assets/images/video-animation/ZM-Animation.gif'
import MiddleBannerPrimary from '../../components/haseeb/MiddleBannerPrimary'
import MiddleBannerSecondary from '../../components/haseeb/MiddleBannerSecondary'
import { Col, Row } from 'reactstrap'
import { FaDotCircle } from 'react-icons/fa'

const VideoAnimation = () => {
    const { t } = useLanguage();
    
    useEffect(() => {
        window.scrollTo(0,0);
    },[])
    
    return (
    <>
    <HelmetProvider>
    <Helmet prioritizeSeoTags>
        <title>software development & digital marketing agency in Germany - IT Junction </title>
    </Helmet>
    </HelmetProvider>
    <Header2/>
    <ServicesBanner
    BannerImg={BannerImg}
    SubTitle={t('servicePages.videoAnimation.subtitle')}
    Title={t('servicePages.videoAnimation.title')}
    />
<section id='website-responsive' className="container-fluid px-0">
<div id='website-responsive'>
        <div className='container-fluid ps-lg-5 ps-4 py-lg-5 py-4'>
            <Row className=''>
                <Col lg='3' className='pb-5'>
                    <div className='pb-md-3 pb-lg-0 pb-3'>
                        <div className='d-flex align-items-center'>
                            <FaDotCircle className='text-ss-primary me-3'/>
                                <Link to='/services/healthcare-solutions' className='' style={{ textDecoration:'none', cursor:'pointer'}}>
                            <span className='fs-ss-18 text-mulish fw-500 text-ss-black'>
                                    {t('services.healthcareSolutions')}
                            </span>
                                </Link>
                        </div>
                        <div className='d-flex align-items-center mt-3'>
                            <FaDotCircle className='text-ss-primary me-3'/>
                                <Link to='/services/branding/' className='' style={{ textDecoration:'none', cursor:'pointer'}}>
                            <span className='fs-ss-18 text-mulish fw-500 text-ss-black'>
                                    {t('services.branding')}
                            </span>
                                </Link>
                        </div>
                        <div className='d-flex align-items-center mt-3'>
                            <FaDotCircle className='text-ss-primary me-3'/>
                                <Link to='/services/graphic-designing' className='' style={{ textDecoration:'none', cursor:'pointer'}}>
                            <span className='fs-ss-18 text-mulish fw-500 text-ss-black'>
                                    {t('services.graphicDesigning')}
                            </span>
                                </Link>
                        </div>
                        <div className='d-flex align-items-center mt-3'>
                            <FaDotCircle className='text-ss-primary me-3'/>
                                <Link to='/services/content-writing/' className='' style={{ textDecoration:'none', cursor:'pointer'}}>
                            <span className='fs-ss-18 text-mulish fw-500 text-ss-black'>
                                    {t('services.contentWriting')}
                            </span>
                                </Link>
                        </div>
                        <div className='d-flex align-items-center mt-3'>
                            <FaDotCircle className='text-ss-primary me-3'/>
                                <Link to='/services/web-development/' className='' style={{ textDecoration:'none', cursor:'pointer'}}>
                            <span className='fs-ss-18 text-mulish fw-500 text-ss-black'>
                                    {t('services.webDevelopment')}
                            </span>
                                </Link>
                        </div>
                        <div className='d-flex align-items-center mt-3'>
                            <FaDotCircle className='text-ss-primary me-3'/>
                                <Link to='/services/app-development/' className='' style={{ textDecoration:'none', cursor:'pointer'}}>
                            <span className='fs-ss-18 text-mulish fw-500 text-ss-black'>
                                    {t('services.appDevelopment')}
                            </span>
                                </Link>
                        </div>
                        <div className='d-flex align-items-center mt-3'>
                            <FaDotCircle className='text-ss-primary me-3'/>
                                <Link to='/services/search-engine-optimization/' className='' style={{ textDecoration:'none', cursor:'pointer'}}>
                            <span className='fs-ss-18 text-mulish fw-500 text-ss-black'>
                                    {t('services.seo')}
                            </span>
                                </Link>
                        </div>
                        <div className='d-flex align-items-center mt-3'>
                            <FaDotCircle className='text-ss-primary me-3'/>
                            <Link to='/services/social-media-marketing/' className='' style={{ textDecoration:'none', cursor:'pointer'}}>
                            <span className='fs-ss-18 text-mulish fw-500 text-ss-black'>
                                {t('services.socialMediaMarketing')}
                            </span>
                                </Link>
                        </div>
                        <div className='d-flex align-items-center mt-3'>
                            <FaDotCircle className='text-ss-primary me-3'/>
                                <Link to='/services/video-animation/' className='' style={{ textDecoration:'none', cursor:'pointer'}}>
                            <span className='fs-ss-24 text-mulish fw-500 text-ss-primary'>
                                {t('services.videoAnimation')}
                            </span>
                                </Link>
                        </div>
                        <div className='d-flex align-items-center mt-3'>
                            <FaDotCircle className='text-ss-primary me-3'/>
                                <Link to='/services/ppc-marketing/' className='' style={{ textDecoration:'none', cursor:'pointer'}}>
                            <span className='fs-ss-18 text-mulish fw-500 text-ss-black'>
                                {t('services.ppcMarketing')}
                            </span>
                                </Link>
                        </div>
                    </div>
                </Col>

                <Col className='ps-lg-4 d-none d-lg-block'>
                        <div className='d-block d-lg-flex align-items-start'>
                          <div className='w-75'>
                          <div className='mb-lg-4 mb-3'>
                            <h2 className='fs-ss-36 text-philos fw-800 text-ss-black'>
                            {t('servicePages.videoAnimation.consultingTitle')}
                            </h2>
                        </div>
                            <p className='fs-ss-16 text-mulish fw-500 text-ss-black lh-1-8'>
                            {t('servicePages.videoAnimation.consultingDescription')}
                            </p>
                            </div>
                            <div className='px-lg-5'>
                            <img className='' src={Animation} alt="Animation" style={{width:"400px"}} />
                        </div>
                    </div>
                </Col>

                <Col className='d-block d-lg-none'>
                          <div className='mb-lg-4 mb-3'>
                            <h2 className='fs-ss-36 text-philos fw-800 text-ss-black'>
                            {t('servicePages.videoAnimation.consultingTitle')}
                            </h2>
                        </div>
                            <p className='fs-ss-16 text-mulish fw-500 text-ss-black lh-1-8'>
                            {t('servicePages.videoAnimation.consultingDescription')}
                            </p>
                            <div className='px-lg-5'>
                            <img className='w-100' src={Animation} alt="Animation" />
                    </div>
                </Col>
            </Row>
        </div>
    </div>

    <section className="container-fluid pb-4">
      <div className='row justify-content-evenly align-items-center'>
        <div className="col-11 col-md-10">
        <div className='mb-lg-4 mb-3'>
             <div className='fs-ss-36 text-philos fw-800 text-ss-black lh-sm'>
             {t('servicePages.videoAnimation.corporateVideoTitle')}
             </div>
         </div>
         <div className=''>
             <p className='fs-ss-16 text-mulish fw-500 text-ss-black lh-1-8'>
             {t('servicePages.videoAnimation.corporateVideoDescription')}
             </p>
        </div>
        </div>
      </div>
    </section>

    <MiddleBannerPrimary
    Title={t('servicePages.videoAnimation.marketingTitle')}
    Para={t('servicePages.videoAnimation.marketingDescription')}
    />
    
    <section className="container-fluid py-4 py-lg-5">
      <div className='row justify-content-evenly align-items-center gy-4'>
        <div className="col-11 col-md-5">
          <img className='w-100' src={Gif1} alt="" />
        </div>
        <div className="col-11 col-md-5">
        <div className='mb-lg-4 mb-3'>
             <div className='fs-ss-36 text-philos fw-800 text-ss-black lh-sm'>
             {t('servicePages.videoAnimation.explainerVideosTitle')}
             </div>
         </div>
         <div className=''>
             <p className='fs-ss-16 text-mulish fw-500 text-ss-black lh-1-8'>
             {t('servicePages.videoAnimation.explainerVideosDescription')}            
             </p>
        </div>
        </div>
      </div>
    </section>

    <MiddleBannerSecondary
    Title={t('servicePages.videoAnimation.visualEffectsTitle')}
    Para={t('servicePages.videoAnimation.visualEffectsDescription')}
    />
    
    <section className="container-fluid pt-4 pt-lg-5">
      <div className='row justify-content-evenly align-items-center'>
        <div className="col-11 col-md-10">
        <div className='mb-lg-4 mb-3'>
             <div className='fs-ss-36 text-philos fw-800 text-ss-black lh-sm'>
             {t('servicePages.videoAnimation.motionGraphicsTitle')}
             </div>
         </div>
         <div className=''>
             <p className='fs-ss-16 text-mulish fw-500 text-ss-black lh-1-8'>
             {t('servicePages.videoAnimation.motionGraphicsDescription')}
             </p>
        </div>
        </div>
      </div>
    </section>

    <section className="container-fluid pb-5">
    <div className="row justify-content-center gy-4">
      <div className="col-11 col-lg-5 border-style-right">
        <div className='pt-lg-5 pt-4 ps-lg-3 pe-lg-5'>
        <div className="fs-ss-30 fw-800 text-ss-primary text-philos">
        {t('servicePages.videoAnimation.whiteboardTitle')}
        </div>
        <div className="fs-ss-16 fw-500 text-mulish lh-lg text-black fst-bold">
        {t('servicePages.videoAnimation.whiteboardDescription')}
        </div>
        </div>
      </div>
      <div className="col-11 col-lg-5 position-border-1 shadow-gif">
        <img src={Img1} alt="" className="w-100" />
      </div>
    </div>
  </section>
  
  <section className="container-fluid pt-4">
      <div className='row justify-content-evenly align-items-center'>
        <div className="col-11 col-md-10">
        <div className='mb-lg-4 mb-3'>
             <div className='fs-ss-36 text-philos fw-800 text-ss-black lh-sm'>
             {t('servicePages.videoAnimation.videoMarketingTitle')}
             </div>
         </div>
         <div className=''>
             <p className='fs-ss-16 text-mulish fw-500 text-ss-black lh-1-8'>
             {t('servicePages.videoAnimation.videoMarketingDescription')}              
             </p>
        </div>
        </div>
      </div>
    </section>

    <section className="container-fluid pt-4">
      <div className='row justify-content-evenly align-items-center'>
        <div className="col-11 col-md-10">
        <div className='mb-lg-4 mb-3'>
             <div className='fs-ss-36 text-philos fw-800 text-ss-black lh-sm'>
             {t('servicePages.videoAnimation.viralMarketingTitle')}
             </div>
         </div>
         <div className=''>
             <p className='fs-ss-16 text-mulish fw-500 text-ss-black lh-1-8' dangerouslySetInnerHTML={{ __html: t('servicePages.videoAnimation.viralMarketingDescription') }}>
             </p>
        </div>
        </div>
      </div>
    </section>

    <section className="container-fluid py-4">
      <div className='row justify-content-evenly align-items-center'>
        <div className="col-11 col-md-10">
        <div className='mb-lg-4 mb-3'>
             <div className='fs-ss-36 text-philos fw-800 text-ss-black lh-sm'>
             {t('servicePages.videoAnimation.showSellTitle')}
             </div>
         </div>
         <div className=''>
             <p className='fs-ss-16 text-mulish fw-500 text-ss-black lh-1-8'>
             {t('servicePages.videoAnimation.showSellDescription')}             
             </p>
        </div>
        </div>
      </div>
    </section>
    </section>
    </>
  )
}

export default VideoAnimation